export const set = (state, action) => {
  return { ...state, token: action.payload }
}
